import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GroupByPipe, FilterUniquePipe, FilterComparisonPipe, ObjectArrayPipe, HasExtendedPipe } from './pipes';

import { NoAccessComponent } from './components/no-access/no-access.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

// Third Party
import { TranslateModule, TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { MaterialModule } from './../modules/material/material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TranslateModule,
    //TranslateModule.forChild({})
    MaterialModule
  ],
  declarations: [
    GroupByPipe, FilterUniquePipe, HasExtendedPipe, FilterComparisonPipe, ObjectArrayPipe,

    PageNotFoundComponent,
    NoAccessComponent,
  ],

  //The SharedModule should not have providers
  //providers: [],

  exports: [//ToDo V: add the other exports
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TranslateModule,
    MaterialModule,

    GroupByPipe, FilterUniquePipe, HasExtendedPipe, FilterComparisonPipe, ObjectArrayPipe,

    PageNotFoundComponent,
    NoAccessComponent,
  ]
})
export class SharedModule {
  constructor(private translate: TranslateService) {

    //Note; translate Service required minimum settings! 
    translate.addLangs(['en'/*, 'ru'*/]);
    translate.setDefaultLang('en');

    // this language will be used as a fallback when a translation isn't found in the current language
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');//http://localhost:4200/assets/i18n/en.json
 
    //translate.get('HELLO', { value: 'world' }).subscribe((res: string) => {
    //  console.log(res);
    //  //=> 'hello world'
    //});
  }
}
